export default "__VITE_ASSET__8c28a11b__"